import CircledCross from "./SVG/circledCross.svg?react";

const CircledCrossIcon = () => {
  return <CircledCross />;
};

export default CircledCrossIcon;
